<section *ngIf="!viewDetails" class="banner">
  <div #air id="air" class="air"></div>
  <app-nav class="w-100"></app-nav>
</section>
<!-- sec profile -->
<section class="v4-bg-img" *ngIf="!viewDetails">
  <div class="container-fluid profile-bar">
    <div class="pos-rel">
      <div class="profile-abs" role="button" (click)="pickImage()">
        <img class="profile-img" [src]="image" alt="loading..." *ngIf="
            image != null || image != 'https://kgate.bc.gov.sa/jsonundefined';
            else placeholder
          " />
        <ng-template #placeholder>
          <img class="profile-img"
            src="https://cdn.vectorstock.com/i/preview-1x/51/98/arab-icon-islamic-man-avatar-muslim-symbol-vector-40505198.webp"
            alt="loading..." />
        </ng-template>
      </div>
    </div>
  </div>
  <p-messages [(value)]="messages" [enableService]="true"></p-messages>
  <div class="container-fluid">
    <div class="row">
      <div *ngIf="assessmentTraining" class="col-md-4 about-card-new mob-my">
        <p-tabView class="v4-user-tab-view" [activeIndex]="0">
          <p-tabPanel header="{{ 'Surveys' | translator }}">
            <div class="v4-flex">
              <!-- <h3 class="v4-color-white">
                {{ "Table of dates" | translator }}
              </h3> -->
              <div>
                <button (click)="changeSurveyTabs('Attempted')" class="{{
                    currentTab == 'Attempted' ? 'bg-primary-custom' : ''
                  }} tab-button right-rouned">
                  {{ "Attempted" | translator }}
                </button>
                <button (click)="changeSurveyTabs('Pending')" class="{{
                    currentTab == 'Pending' ? 'bg-primary-custom' : ''
                  }} tab-button left-rouned">
                  {{ "pending" | translator }}
                </button>
              </div>
            </div>
            <!-- <span class="line"></span> -->
            <!-- <h5 class="mb-3">لا توجد أي اختبارات أو استبيانات قادمة</h5> -->

            <div class="scroll v4-px-3 my-3">
              <div class="card wide-card-ui p-2 my-2 222" *ngFor="let survey of filteredSurveys">
                <div class="d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="v4-ml-1-2">
                      <div class="time-flex">
                        <span class="month">{{
                          formatDateNew(survey.startDate) | date : "MMM"
                          }}</span>
                        <span class="day">{{
                          formatDateNew(survey.startDate) | date : "dd"
                          }}</span>
                        <span class="year">{{
                          formatDateNew(survey.startDate) | date : "yyyy"
                          }}</span>
                      </div>
                    </div>
                    <div>
                      <img class="profile-card-img" src="{{ fileUrl + survey.headerImage }}" alt="loading"
                        onerror="this.src='../../../../assets/assessment.png'" />
                    </div>
                    <div class="column mx-2">
                      <div class="d-flex">
                        <h5 class="name-ui">{{ survey.name }}</h5>
                      </div>
                      <span class="date-ui purple-ash mx-2">({{ "survey" | translator }})</span>
                      <span class="date-ui">{{ survey.createdAt | date }}</span>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div *ngIf="currentTab != 'Attempted'" class="d-flex align-items-center">
                      <button *ngIf="
                          isCurrentDateTimeGreaterThanEndDate(survey.endDate);
                          else ShowClosed
                        " (click)="
                          launchUrl(
                            survey._id,
                            'survey',
                            survey.courseId ? survey.courseId : ''
                          )
                        " class="submit-btn">
                        {{ "Start" | translator }}
                      </button>
                      <ng-template #ShowClosed>
                        <button [disabled]="true" class="submit-btn">
                          {{ "Closed" | translator }}
                        </button>
                      </ng-template>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="profile-btn">
                      <i class="pi pi-eye"></i>
                    </div>
                    <div class="profile-btn">
                      <i class="pi pi-download"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p-tabPanel>
          <p-tabPanel header="{{ 'Assessments' | translator }}">
            <div class="v4-flex">
              <!-- <h3 class="v4-color-white">
                {{ "Table of dates" | translator }}
              </h3> -->
              <div>
                <button (click)="changeAssessmentsTabs('Attempted')" class="{{
                    assessmentsTab == 'Attempted' ? 'bg-primary-custom' : ''
                  }} tab-button right-rouned">
                  {{ "Attempted" | translator }}
                </button>
                <button (click)="changeAssessmentsTabs('Pending')" class="{{
                    assessmentsTab == 'Pending' ? 'bg-primary-custom' : ''
                  }} tab-button left-rouned">
                  {{ "pending" | translator }}
                </button>
              </div>
            </div>
            <!-- <span class="line"></span> -->
            <div class="scroll v4-px-3 my-3">
              <div class="card wide-card-ui p-2 my-2" *ngFor="let assessment of filteredAssessments">
                <div class="d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="v4-ml-1-2">
                      <div class="time-flex">
                        <span class="month">{{
                          formatDateNew(assessment.startDate) | date : "MMM"
                          }}</span>
                        <span class="day">{{
                          formatDateNew(assessment.startDate) | date : "dd"
                          }}</span>
                        <span class="year">{{
                          formatDateNew(assessment.startDate) | date : "yyyy"
                          }}</span>
                      </div>
                    </div>
                    <div>
                      <img class="profile-card-img" src="{{ fileUrl + assessment.headerImage }}" alt="loading"
                        onerror="this.src='../../../../assets/assessment.png'" />
                    </div>
                    <div class="column mx-2">
                      <div class="d-flex">
                        <h5 class="name-ui">{{ assessment.name }}</h5>
                      </div>
                      <span class="date-ui purple-ash mx-2">({{ "Assessment" | translator }})</span>
                      <span class="date-ui">{{
                        assessment.createdAt | date
                        }}</span>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div *ngIf="assessmentsTab != 'Attempted'" class="d-flex align-items-center">
                      <button *ngIf="
                          isCurrentDateTimeGreaterThanEndDate(
                            assessment.endDate
                          );
                          else ShowClosed
                        " (click)="
                          launchUrl(
                            assessment._id,
                            'assessment',
                            assessment.courseId ? assessment.courseId : ''
                          )
                        " class="submit-btn">
                        {{ "Start" | translator }}
                      </button>
                      <ng-template #ShowClosed>
                        <button [disabled]="true" class="submit-btn">
                          {{ "Closed" | translator }}
                        </button>
                      </ng-template>
                    </div>
                    <div *ngIf="assessmentsTab == 'Attempted'" class="d-flex align-items-center">
                      <button pTooltip='{{ "Certificate" | translator }}' tooltipPosition="top" *ngIf="assessment.showCert" (click)="launchUrl(assessment._id, 'assessment')"
                        class="profile-btn">
                        <i class="pi pi-eye"></i>
                      </button>
                      <button pTooltip='{{ "Results" | translator }}' tooltipPosition="top"
                        *ngIf="assessment.showResult && assessment?.results[0]"
                        (click)="loadResults(assessment?.results[0])" class="profile-btn">
                        <i class="pi pi-download"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
      <div class="col-md-4 about-card">
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="v4-color-white">
            {{ "personal information" | translator }}
          </h3>
          <i *ngIf="!!editData" (click)="openUserUpdateModal = true" class="pi pi-pencil icon-ui"></i>
        </div>
        <span class="line"></span>
        <div>
          <div class="d-flex my-2">
            <span><i class="pi pi-pencil icon-ui"></i></span>
            <span class="info">{{ "full name" | translator }}</span>
            <span class="info-ans">&nbsp;:&nbsp;{{ user.username }}</span>
          </div>
          <div class="d-flex my-2">
            <span><i class="pi pi-envelope icon-ui"></i></span>
            <span class="info">{{ "E-mail" | translator }}</span>
            <span class="info-ans">&nbsp;:&nbsp;{{ user.email }}</span>
          </div>
          <div class="d-flex my-2">
            <span><i class="pi pi-mobile icon-ui"></i></span>
            <span class="info">{{ "phone number" | translator }}</span>
            <span class="info-ans">&nbsp;:&nbsp;{{ user.phone }}</span>
          </div>
          <div class="d-flex my-2">
            <span><i class="pi pi-users icon-ui"></i></span>
            <span class="info">{{ "Sex" | translator }}</span>
            <span class="info-ans">&nbsp;:&nbsp;{{ user.gender }}</span>
          </div>
          <div class="d-flex my-2">
            <span><i class="pi pi-id-card icon-ui"></i></span>
            <span class="info">{{ "National Identity" | translator }}</span>
            <span class="info-ans">&nbsp;:&nbsp;{{ user.national_id }}</span>
          </div>

          <!--  -->
          <div *ngIf="ous" class="d-flex align-items-center justify-content-center mt-5">
            <div class="d-flex flex-row gap-2 align-items-center justify-content-start flex-wrap">
              <span *ngFor="let ou of ous; let i = index" class="ouBread">
                <img src="{{ fileUrl + ou.image }}" class="img-fluid 111" *ngIf="checkisImg(ou.image); else elseBlock"
                  style="
                    height: 22px;
                    max-width: 22px;
                    margin-left: 5px;
                    background: white;
                    border-radius: 3px;
                    padding: 2px;
                  " />
                <ng-template #elseBlock>
                  <i style="margin-left: 10px" class="{{ ou.image }}"></i>
                </ng-template>
                {{ ou?.name }}

                <span *ngIf="i + 1 < ous.length">
                  <i class="pi pi-chevron-left light-white"> </i>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- <span class="line"></span>
        <div class="col-lg-12 w-100" *ngIf="ous">
          <div class="row">
            <div class="col-lg-4 my-2 mx-1" *ngFor="let ou of ous; let i = index">
              <div class="ou-boxes">
                <div class="d-flex justify-content-between mt-1">
                  <span class="ou-list-hover v4-font-600">
                    {{ou?.type?.name}}</span>
                </div>
                <div class="ou-list">
                  <span> {{ ou?.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <div class="col-md-4 about-card-left">
        <h3 class="v4-color-white">
          {{ "Progress bar by organizational unit" | translator }}
        </h3>
        <span class="line"></span>
        <!-- <p class="card-description">لا توجد بيانات</p> -->
        <div class="bar-box mt-4">
          <div class="d-flex justify-content-between mb-2">
            <label class="info">{{ "The progress bar" | translator }}</label>
            <span><i class="pi pi-eye icon-eye" (click)="progressModal = true"></i></span>
          </div>
          <div class="row">
            <div class="col-11 p-0">
              <p-progressBar styleClass="centered-progress" [value]="totalProgressPercentage"></p-progressBar>
            </div>
            <div class="col-1 p-0 px-1">({{ totalProgressPercentage }}%)</div>
          </div>
        </div>
        <app-rating-graph></app-rating-graph>
      </div>
    </div>
  </div>

  <!-- Assigned Courses -->

  <div class="{{
      trainingView == 'List View'
        ? 'container-fluid p-0 bg-lightt-v4'
        : 'container-fluid bg-lightt-v4 p-0'
    }}">
    <div class="container d-contents">
      <div class="custom-responsive">
        <div class="row my-2 py-4">
          <div class="flex-between-column my-3">
            <div>
              <img class="img-icon" src="../../../assets/v-4-icone/Group.svg" alt="loading" />
              <label class="border-bottom my-3">
                <h3>
                  <b>{{ "training courses" | translator }}</b>
                </h3>
              </label>
            </div>
            <div class="d-flex justify-content-center align-items-center my-3">
              <p-selectButton class="custom-select v4-active" [options]="trainingViewOptions" [(ngModel)]="trainingView"
                optionLabel="name" optionValue="value"></p-selectButton>
            </div>
            <div *ngIf="trainingView == 'List View'" class="d-flex justify-content-center mt-2">
              <div class="w-350-px">
                <h6 class="desc-heading mb-2">
                  <i class="fa-solid fa-filter mx-2"></i>{{ "training types" | translator }}
                </h6>

                <p-dropdown class="ppp-dropdown" [(ngModel)]="selectedTraining" (onChange)="filterByStatus('null')"
                  [options]="tabs" optionLabel="arabic"
                  placeholder="{{ 'Select a training type' | translator }}"></p-dropdown>
              </div>
            </div>
          </div>
          <ng-container *ngIf="trainingView == 'List View'">
            <div class="row row-bg m-0">
              <div class="col-md-3 px-2">
                <button [ngClass]="ongoing ? 'course-btn-ui-active' : ''" (click)="filterByStatus('ONGOING')"
                  class="course-btn-ui my-2 font-600">
                  <i class="fa fa-hourglass-start mx-2"></i>{{ "current" | translator }} ({{
                  trainingStatusCount?.ONGOING
                  }})
                </button>
              </div>

              <div class="col-md-3 px-2">
                <button [ngClass]="pending ? 'course-btn-ui-active' : ''" (click)="filterByStatus('')"
                  class="course-btn-ui my-2 font-600">
                  <i class="pi pi-arrow-circle-left mx-1"></i>{{ "Coming" | translator }} ({{
                  trainingStatusCount?.UPCOMING
                  }})
                </button>
              </div>
              <div class="col-md-3 px-2">
                <button (click)="filterByStatus('COMPLETE')" class="course-btn-ui my-2 font-600"
                  [ngClass]="complete ? 'course-btn-ui-active' : ''">
                  <i class="fa fa-check mx-2"></i>{{ "completed" | translator }} ({{
                  trainingStatusCount?.COMPLETE
                  }})
                </button>
              </div>
              <div class="col-md-3 px-2">
                <button (click)="filterByStatus('ATTENDANCE_SHORT')" class="course-btn-ui my-2 font-600"
                  [ngClass]="attendanceShort ? 'course-btn-ui-active' : ''">
                  <i class="pi pi-times mx-2"></i>{{ "Short of attendance" | translator }} ({{
                  trainingStatusCount?.ATTENDANCE_SHORT
                  }})
                </button>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="trainingView == 'Calender View'">
            <app-training-calander [userProfileFlag]="true"></app-training-calander>
          </ng-container>

          <!-- <app-training-program-view></app-training-program-view> -->

          <div class="col-lg-3" *ngFor="let course of cardData" [hidden]="trainingView != 'List View'">
            <div class="shaddow m-2" style="cursor: pointer">
              <p-card class="new-card" [header]="course.title" (click)="openCourse(course._id)">
                <div *ngIf="course?.programId?.title" (click)="op.toggle($event); $event.stopPropagation()"
                  style="color: rgb(247 183 0)" class="info-ans">
                  <i class="pi pi-fw pi-th-large"></i>&nbsp;{{
                  course?.programId?.title
                  }}
                </div>
                <span class="info-ans">{{ course?.type?.arabic }}</span>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="info-ans">
                    {{ course?.start_date | date }} -
                    {{ course?.end_date | date }}
                  </div>

                  <h4></h4>

                  <p-overlayPanel #op [style]="{ width: '40%' }" [showCloseIcon]="true">
                    <ng-template pTemplate="content">
                      <app-training-program-view [programID]="course?.programId?._id"
                        [from]="'user-profile'"></app-training-program-view>
                    </ng-template>
                  </p-overlayPanel>

                  <!-- <span *ngIf="complete">
                    <a *ngIf="!loadingCert || certificateData?._id != course?._id;else certLoader"
                      class="d-flex align-items-baseline" style="cursor: pointer;"
                      (click)="printCertificate($event, course)" pTooltip="Download Certificate">
                      <img class="certificate" src="../../../assets/certify.svg" alt="loading" />
                    </a>
                    <ng-template #certLoader>
                      <p-progressSpinner strokeWidth="2px" />
                    </ng-template>
                  </span> -->
                </div>

                <!-- <br>
              <span class="info-ans">{{course?.end_date | date}}</span> -->
                <ng-template pTemplate="header">
                  <div class="image-card">
                    <img *ngIf="course.image" class="image" [src]="staticURL + course.image" />
                    <img *ngIf="!course.image" class="image" src="../../../../assets/rectangle_32.png" />
                  </div>
                </ng-template>
              </p-card>
            </div>
          </div>
          <app-no-data [hidden]="cardData?.length > 0"></app-no-data>
        </div>
      </div>
    </div>
  </div>

  <!-- Suggested Courses Section -->
  <div class="container-fluid p-0 bg-lightt-v4 my-4">
    <div class="container d-contents">
      <div class="custom-responsive">
        <div class="row my-2 py-4">
          <div class="flex-between-column">
            <div>
              <img class="img-icon" src="../../../assets/v-4-icone/Group.svg" alt="loading" />
              <label class="border-bottom my-3">
                <h3>
                  <b>{{ "Suggested Courses" | translator }}</b>
                </h3>
              </label>
            </div>
            <div class="flex-col-card mob-px w-350-px-2">
              <label class="desc-heading mb-2">
                <i class="fa-solid fa-calendar-days mx-2"></i>
                {{ "Date" | translator }}
              </label>
              <div class="w-100">
                <p-calendar [(ngModel)]="rangeDates" view="month" dateFormat="mm/yy"
                  (ngModelChange)="getUserSuggestedCurses()" [readonlyInput]="true"></p-calendar>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="!!skilledCourses">
            <div class="col-lg-3" *ngFor="let course of skilledCourses[0]?.trainings">
              <div class="shaddow m-2" style="cursor: pointer">
                <p-card class="new-card flex-col-card" [header]="course?.trainingId?.title">
                  <p class="info-ans">{{ course?.type?.arabic }}</p>
                  <p class="info-ans m-1">
                    {{ course?.trainingId?.start_date | date }} -
                    {{ course?.trainingId?.end_date | date }}
                  </p>
                  <span class="d-flex">
                    <button class="v4-btn-every py-2 px-3 m-1" (click)="assAttendeesInitiate(course)">
                      <i class="pi pi-check v4-ml-2"></i>{{ "Request Course" | translator }}
                    </button>
                    <button class="v4-btn-every py-2 px-3 m-1" (click)="openCourse(course?.trainingId._id)">
                      <i class="pi pi-eye v4-ml-2"></i>{{ "Preview" | translator }}
                    </button>
                  </span>
                  <ng-template pTemplate="header">
                    <div class="image-card">
                      <img *ngIf="course?.trainingId?.image" class="image"
                        [src]="staticURL + course.trainingId?.image" />
                      <img *ngIf="!course?.trainingId?.image" class="image" src="../../../../assets/bg/alt-img.png" />
                    </div>
                  </ng-template>
                </p-card>
              </div>
            </div>
            <app-no-data [hidden]="skilledCourses[0]?.trainings?.length > 0"></app-no-data>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-toast></p-toast>
  <!-- comments code  -->
  <label class="border-bottom m-3">
    <h3 class="m-2">
      <b><i class="pi pi-comments mx-2 font-1-4"></i>{{ "comments" | translator }}</b>
    </h3>
  </label>
  <div class="row">
    <div class="col-md-5 poss-rel">
      <div class="card v4-bg border-none card-mobile-alignment mob-mx">
        <div class="d-flex justify-content-between align-items-center mx-3">
          <span class="custom-pagination-text">{{ "comment result" | translator }} <br />{{ currentPage }} -
            {{ first + rows > totalRecords ? totalRecords : first + rows }} من
            {{ totalRecords }}</span>
          <div class="d-flex">
            <span class="custom-pagination" (click)="moveToLast(true)"><i
                class="pi pi-fw pi-angle-double-right icon-x2"></i></span>
            <span class="custom-pagination" (click)="changePage(currentPage - 1)"><i
                class="pi pi-fw pi-angle-right icon-x2"></i></span>
            <span class="custom-pagination" (click)="changePage(currentPage + 1)"><i
                class="pi pi-fw pi-angle-left icon-x2"></i></span>
            <span class="custom-pagination" (click)="moveToLast(false)"><i
                class="pi pi-fw pi-angle-double-left icon-x2"></i></span>
          </div>
        </div>
        <div class="d-flex p-3">
          <span class="p-float-label w-100">
            <input type="text" id="float-label" class="w-100 v4-input" (keyup)="applyFilterGlobal($event, 'contains')"
              pInputText placeholder="{{ 'Search for a name or number' | translator }}" />
            <label for="float-label v4-color-white">{{
              "Discus" | translator
              }}</label>
          </span>
        </div>

        <p-dataView #dv [value]="filteredData" filterBy="_id.name,_id.id,comments[0].text" [rows]="10"
          [paginator]="true" [sortField]="sortField" [sortOrder]="sortOrder" (onPage)="onPageChange($event)"
          paginatorPosition="none" emptyMessage="لاتوجد بيانات">
          <ng-template let-item let-index="rowIndex" pTemplate="listItem">
            <div class="list-item custom-w-90 d-flex flex-row flex-nowrap flex-wrap align-items-center"
              [ngClass]="currentComment._id._id == item._id._id ? 'active' : ''" (click)="changeView(item)">
              <p-button [label]="index + 1 + (currentPage - 1) * 10"
                styleClass="p-button-outline p-button-sm p-button-text indexnum m-2"></p-button>

              <div>
                <p class="mb-0">{{ item._id.id }}</p>
                <p class="mb-2">
                  <b>{{ item._id.name }}</b>
                </p>
              </div>
            </div>
          </ng-template>
        </p-dataView>
      </div>
    </div>

    <div class="col-md-7">
      <div class="bg-view mob-mx">
        <app-no-data *ngIf="!currentComment || currentComment.comments?.length == 0"></app-no-data>
        <p-accordion *ngIf="currentComment?.comments && currentComment.comments.length > 0">
          <br />

          <section *ngFor="let comment of currentComment.comments">
            <div class="row mb-2">
              <div class="col-lg-12 col-sm-6">
                <div class="card v4-card-7">
                  <div class="card-body">
                    <div class="row my-2 d-flex align-items-center">
                      <div class="col-lg-8 p-3">
                        <h5 class="card-title float-right v4-color-white" style="font-size: 1rem">
                          {{ currentComment._id.name }}
                        </h5>
                        <p style="font-size: 0.7rem" class="card-text text-muted float-right pt-2">
                          {{
                          comment.createdAt
                          | date : "EEEE, MMMM d, y, h:mm:ss a"
                          }}
                        </p>
                      </div>

                      <div class="col-lg-4 p-3 d-flex justify-content-end">
                        <div class="d-flex">
                          <span class="btn-flex">
                            <img *ngIf="
                                checkisImg(comment.ou.image_sq);
                                else elseBlock
                              " src="{{ staticURL }}{{ comment.ou.image_sq }}" class="img-fluid p-1"
                              style="max-height: 50px; max-width: 100px" />
                            <ng-template #elseBlock>
                              <i class="{{ comment.ou.image_sq }} p-2" style="font-size: 1rem"></i>
                            </ng-template>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex p-3">
                    <div class="border-box bg-white-v4 float-right border" style="border-radius: 12px">
                      <div class="p-2 mb-0">
                        <label class="text-bold text-primary-v4 float-right">{{
                          user.username
                          }}</label>
                      </div>
                      <div class="p-2 mt-0">
                        <h2 style="font-size: 1rem" class="text-bold v4-color-white">
                          {{ comment.text }}
                        </h2>
                      </div>
                    </div>
                  </div>

                  <div [hidden]="
                      !comment.rejectReason || comment.rejectReason == null
                    " class="d-flex align-items-center p-3 mt-0 pt-0">
                    <i *ngIf="comment.status == 'APPROVED'" class="fas fa-thumbs-up float-right fa-lg mx-2"
                      style="color: #2b67ef; font-size: 35px"></i>
                    <i *ngIf="comment.status == 'REJECTED'" class="fas fa-thumbs-down float-right fa-lg mx-2"
                      style="color: #ce1414; font-size: 35px"></i>
                    <div class="border-box bg-white-v4 float-right border" style="border-radius: 12px">
                      <div class="p-2 mb-0">
                        <label class="text-bold text-danger float-right">الرد</label>
                      </div>
                      <div class="p-2 mt-0">
                        <h2 style="font-size: 1rem" class="text-bold v4-color-white">
                          {{ comment.rejectReason }}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-6"></div>
            </div>

            <!-- <p-accordionTab>
                  <ng-template pTemplate="header">
                    <div class="flex align-items-center w-100">
                      <div class="d-flex justify-content-between">
                        <div>
                          <span class="vertical-align-middle m-2">{{comment.data_data.name}}</span>
                        </div>
                        <div>
                          <span>({{comment.createdAt | date}})</span>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <p-card>
                    <h4><b>تعليق</b></h4>
                    <span>{{comment.text}}</span>
                  </p-card>
                  <p-card>
                    <h4><b>سبب </b></h4>
                    <span [innerHTML]="comment.rejectReason | safeHTML"></span>
                  </p-card>


                </p-accordionTab> -->
          </section>
        </p-accordion>
      </div>
    </div>
  </div>
  <!-- comments code end -->
</section>
<!-- sec profile end-->
<!-- progress detail modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Progress bar by organizational unit' | translator }}"
  [(visible)]="progressModal" [modal]="true" [style]="{ width: '95vw', maxWidth: '1200px' }" [draggable]="false"
  [resizable]="false">
  <div class="row">
    <div class="col-md-6 px-2" *ngFor="let ministry of progressDetails">
      <div class="row progress-box d-flex align-items-center my-1">
        <div class="col-7 d-flex align-items-center p-0">
          <span>
            <img *ngIf="checkisImg(ministry?.obj?.icon); else elseBlock" src="{{ staticURL }}{{ ministry?.obj?.icon }}"
              class="progress-img" />
            <ng-template #elseBlock>
              <i class="{{ ministry?.obj?.icon }} p-2" style="font-size: 1rem"></i>
            </ng-template>
          </span>
          <span class="">
            {{ ministry?.obj?.label }}
          </span>
        </div>
        <div class="col-5 p-0">
          <div class="row">
            <div class="col-11 p-0">
              <p-progressBar [value]="ministry?.percent"></p-progressBar>
            </div>
            <div class="col-1 p-0 px-1">({{ ministry?.percent }}%)</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- End Progress modal -->
<div class="bg-lightt">
  <app-show-detail *ngIf="viewDetails" [courseDetails]="courseDetailsUserProfile"></app-show-detail>
</div>

<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<div #certificateElement id="download-data" style="display: none; object-fit: contain" *ngIf="certificateData">
  <div style="padding: 30px">
    <div style="text-align: center; margin: 20px 0px">
      <img src="../../assets/sbccolorlogo-01.png" style="height: 60px" />
    </div>

    <div style="text-align: center; margin-top: -60px">
      <div>
        <!-- <img src="../../assets/badge/{{converResultStatusByPercentageImage(getProgress(assSocres[currentnumber]?.results))}}.png"> -->
      </div>
      <div style="
          background-color: rgb(234, 234, 234);
          padding-top: 100px;
          margin-top: -100px;
          padding-bottom: 100px;
          padding-left: 30px;
          padding-right: 30px;
          color: #06263e;
        ">
        <span style="color: #130b69; margin: 20px 0px; font-weight: 600">
          {{ certificateData?.courseName }}
        </span>

        <table class="table" style="margin: 30px auto">
          <tbody>
            <tr style="text-align: right">
              <td colspan="2" style="
                  background-color: #06263e !important;
                  color: white !important;
                ">
                {{ "Course title" | translator }} &nbsp;&nbsp;:&nbsp;&nbsp;
                {{ certificateData?.courseType }}
              </td>
            </tr>
            <tr style="text-align: right; color: #06263e !important">
              <td>الاسم</td>
              <td>{{ certificateData?.awardedTo }}</td>
            </tr>
            <tr style="text-align: right; color: #06263e !important">
              <td>
                {{ "Date" | translator }}
              </td>
              <td>
                {{ certificateData?.courseStartDate | date }} -
                {{ certificateData?.courseEndDate | date }}
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <span style="color: #130b69; margin: 20px 0px; font-weight: 600">معدل الاختبار حسب الجهات</span>
          <table class="table mt-1" style="margin-left: auto; margin-right: auto">
            <tbody></tbody>
          </table>
        </div>
      </div>

      <div style="
          position: relative;
          bottom: 50px;
          right: 30px;
          text-align: start;
          color: #28275b;
        ">
        <h5>مع تمنياتنا لكم بالتوفيق والسداد</h5>
      </div>
    </div>
  </div>

  <div style="
      position: relative;
      bottom: 0;
      left: 0;
      text-align: center;
      background-color: #06263e;
      height: 45px;
      padding: 5px 15px;
      color: white;
    ">
    <p>المركز السعودي للأعمال © 2023</p>
  </div>

  <div style="
      background-image: url(../../assets/badge/Object-05.png);
      background-size: contain;
      background-repeat: no-repeat;
      position: relative;
      bottom: 170px;
      height: 210px;
      width: 210px;
      left: -3px;
      float: left;
      text-align: center;
    ">
    <div style="padding-left: 25px; color: #06263e; font-size: smaller">
      الإدارة العامة للشراكات <br />
      وتطوير القدرات <br />
      <span style="font-size: xx-small">تواصل معنا</span><br />
    </div>
  </div>
</div>

<!-- Edit User Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Update user data' | translator }}"
  [(visible)]="openUserUpdateModal" [style]="{ margin: '0rem 1rem', width: '70vw' }" [maximizable]="true">
  <app-signup-form [hideRole]="true" (updatedData)="handleUpdatedUserData($event)" *ngIf="!!editData" [type]="'UPDATE'"
    [data]="editData"></app-signup-form>
</p-dialog>
<p-dialog [header]="'assessment Results' | translator" [maximizable]="true" [(visible)]="openQuestionModal"
  [style]="{ width: '60vw' }">
  <div class="{{ question.score === 0 ? 'v4-bg-red' : 'v4-bg-green' }}"
    *ngFor="let question of questionsToShow; let i = index">
    <div class="" *ngIf="!scoreHideQuestions.includes(question.type)">
      <div class="d-flex column label-score">
        <span class="ans-color v4-color-white mt-4">{{
          "Score" | translator
          }}</span>
      </div>
      <p-inputNumber inputId="integeronly" class="input-number-field" [placeholder]="'Score' | translator" [inputStyle]="{
                              'background-color': 'transparent',
                              'border': question.score === 0 ? 'solid 2px red' : 'solid 3px green',
                              'border-radius': '8px',
                              'width': '100%',
                              'margin-right': '40px',
                              'margin-top': '2px',
                          }" [(ngModel)]="question.score" [disabled]="true" />
    </div>
    <div *ngIf="
        !scoreHideQuestions.includes(question.type) &&
        question.meta.feedback != undefined &&
        question.meta.feedback.trim() != ''
      " class="d-flex column label-score mb-2">
      <span class="ans-color v4-color-white">{{
        "Feedback" | translator
        }}</span>
    </div>
    <p-editor [readonly]="true" *ngIf="
        !scoreHideQuestions.includes(question.type) &&
        question.meta.feedback != undefined &&
        question.meta.feedback.trim() != ''
      " [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
    <app-question-template [disabled]="true" [question]="question" #questionDiv></app-question-template>
  </div>
</p-dialog>
<app-footer></app-footer>